<script setup lang="ts">
import { format } from "date-fns";
import { es, pt } from "date-fns/locale";

const props = defineProps({
  label: {
    type: [String, Number, Date],
    default: null,
    undefined,
  },
});

const { locale } = useI18n();

const dateLabel = computed(() => {
  if (props.label === null) {
    return "";
  } else if (props.label !== undefined) {
    return new Date(props.label);
  } else {
    return "";
  }
});
</script>
<template>
  <UButton
    icon="i-heroicons-calendar-days-20-solid"
    type="text"
    class="bg-white !ring-0 border-none text-black w-full rounded-xs text-center py-3 hover:text-cerise-red-600 hover:bg-white"
    :label="dateLabel ? format(dateLabel, 'd MMM, yyy', { locale: locale == 'es' ? es : pt }) : 'dd/mm/yyyy'"
  />
</template>
